import { Reveal } from "./Reveal";

const SectionHeading = ({ label, number, title, dark = false, className = "" }) => (
  <div className={`flex items-start justify-between gap-6 mb-14 sm:mb-20 ${className}`}>
    <div>
      <Reveal>
        <p className={`label-tech flex items-center gap-3 mb-6 ${dark ? "text-paper/50" : "text-graphite"}`}>
          {number && <span className="text-cobalt">{number}</span>}
          <span className={`inline-block w-8 h-px ${dark ? "bg-paper/30" : "bg-ink/30"}`} />
          {label}
        </p>
      </Reveal>
      <Reveal i={1}>
        <h2 className={`t-h2 max-w-3xl ${dark ? "text-paper" : "text-coal"}`}>{title}</h2>
      </Reveal>
    </div>
  </div>
);

export default SectionHeading;
